import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-002a1c49"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-scheduling" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "课程排课管理", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增约课")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("未上课")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("已上课")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("重新排课")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消课时")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("上课情况")
const _hoisted_13 = { class: "pagination-container" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("已占用")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("空闲")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("打卡补全")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("爽约")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("教学事故")
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("提交")

import { ref, reactive, watch, computed } from 'vue'
import { getCourseSchedulingList, getTeacherList, getAppointmentTime, getCampusList, addCourseScheduling, changeClassStatus, fetchSubmitCancelClass } from '@/service/main/system/system'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Search, Refresh, Plus } from '@element-plus/icons-vue'
import { useStore } from '@/store'
import AddClass from './components/addClass.vue'

// 暴露图标组件给模板使用

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const SearchIcon = Search
const RefreshIcon = Refresh
const PlusIcon = Plus

const tableData = ref([])
const phone = ref('')
const dialogVisible = ref(false)
const formRef = ref()
const timeValue = ref('')
const loading = ref(false)
const submitLoading = ref(false)
const statusLoading = ref(false)
const total = ref(0)
const pageSize = ref(10)
const currentPage = ref(1)

const addDialogVisible = ref(false)

const formRules = {
  teacherId: [{ required: true, message: '请选择老师' }],
  appointmentDate: [{ required: true, message: '请选择日期' }],
  classRoom: [{ required: true, message: '请选择教室' }]
}

const form = reactive({
  id: '', 
  teacherId: '',
  teacherName: '',
  appointmentTimeId: '',
  appointmentDate: '',
  lessonTimeKey: '',
  lessonTime: '',
  classTableStatueId: '',
  campus: '',
  classRoom: ''
})
const statusForm = reactive({
  type: '',
  teacherId:'',
  timeClassId:''
})
const modalshow = ref(false)
const teacherList = ref([])
const timeList = ref([])
const campusList = ref([])

// 获取 store 中的权限数据
const store = useStore()
const permissions = computed(() => store.state.permissions)
const roles = computed(() => store.state.roles)

// 调试权限数据
console.log('当前权限:', permissions.value)
console.log('当前角色:', roles.value)
console.log('store.state:', store.state)

const getList = () => {
  loading.value = true
  getCourseSchedulingList('/pc/classTable/getList', {
    phone: phone.value,
    pageNum: currentPage.value,
    pageSize: pageSize.value
  }).then((res: any) => {
    tableData.value = res?.rows || []
    total.value = res?.total || 0
  }).finally(() => {
    loading.value = false
  })
}

const resetSearch = () => {
  phone.value = ''
  currentPage.value = 1
  getList()
}

const handleSizeChange = (val: number) => {
  pageSize.value = val
  getList()
}

const handleClose = (e: boolean) => {
  console.log(e)
  if(e) {
    currentPage.value = 1
    getList()
  }
  addDialogVisible.value = false
}

const handleCurrentChange = (val: number) => {
  currentPage.value = val
  getList()
}

const changeStatus = (row: any) => {
  modalshow.value = true
  statusForm.teacherId = row.teacherId
  statusForm.timeClassId = row.id
}
// 修改上课状态
const handleSubmit = () => {
  statusLoading.value = true
  if (!statusForm.type) {
    ElMessage.warning('请选择上课情况')
    return
  }
  changeClassStatus('/pc/teacherInfo/editSituation', { ...statusForm }).then((res) => {
    if (res?.code === 200) {
      ElMessage.success('修改上课状态成功')
      modalshow.value = false
      statusForm.type = ''
      statusForm.teacherId = ''
      statusForm.timeClassId = ''
      getList()
    }
  }).finally(() => {
    statusLoading.value = false
  })
}

const fetchTeacherList = async () => {
  const res = await getTeacherList('/pc/userInfo/teacherDropDown')
  teacherList.value = res?.data || []
}

const fetchTimeList = async () => {
  if (!form.teacherId) return
  const res = await getAppointmentTime('/pc/userInfo/timeDropDown', { userId: form.teacherId })
  timeList.value = res?.data.map((item: any) => ({
    label: `${item.appointmentDate} - ${item.appointmentTimeValue}`,
    ...item
  })).filter((item: any) => item.isArrange === 1)
}

const fetchCampusList = async () => {
  if (!form.lessonTimeKey || !form.appointmentDate) return
  const res = await getCampusList('/pc/classRoom/roomDropDown', {
    classTableId: '537f2a58-517d-4245-85d3-4c2edead5e08',
    date: form.appointmentDate,
    timeSlot: form.lessonTimeKey
  })
  campusList.value = res?.data.map((item: any) => ({
    ...item,
    isSelected: false
  }))
}

const handleTeacherChange = (val: string) => {
  const teacher = teacherList.value.find((t: any) => t.userId === val)
  form.teacherName = teacher?.realName || ''
  form.appointmentTimeId = ''
  form.appointmentDate = ''
  form.lessonTimeKey = ''
  form.lessonTime = ''
  form.campus = ''
  form.classRoom = ''
  timeList.value = []
  campusList.value = []
  fetchTimeList()
}

const handleTimeChange = (val: string) => {
  const time = timeList.value.find((t: any) => t.label === val)
  form.lessonTimeKey = time?.appointmentTimeKey || ''
  form.lessonTime = time?.appointmentTimeValue || ''
  form.appointmentDate = time?.appointmentDate || ''
  form.appointmentTimeId = time?.objId || ''
  form.campus = ''
  form.classRoom = ''
  campusList.value = []
  fetchCampusList()
}

const handleCheckboxChange = (val: boolean, currentRow: any, campusRow: any) => {
  if (val) {
    // 遍历所有校区，将所有教室设为未选中
    campusList.value.forEach((campus: any) => {
      campus.childList?.forEach((item: any) => {
        if (item !== currentRow) {
          item.isSelected = false;
        }
      });
    });

    // 设置 form 的相关字段
    form.campus = campusRow.campusId; // 校区 ID
    form.classTableStatueId = currentRow.id; // 当前行的 ID
    form.classRoom = currentRow.classroomId; // 教室 ID
  } else {
    // 如果取消选中，清空相关字段
    form.campus = '';
    form.classTableStatueId = '';
    form.classRoom = '';
  }
};
const handleEdit = (row: any) => {
  fetchTeacherList()
  dialogVisible.value = true; // 打开弹窗
  form.id = row.id; // 将当前行的 id 赋值给 form
};

// 取消上课
const handleCancelClass = (classTableId: string) => {

  ElMessageBox.confirm(
    '确定取消该课程吗？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(async () => {
      try {
        const res = await fetchSubmitCancelClass({
          record: {
            classTableId //课表主键
          }
        })
        ElMessage({
          type: 'success',
          message: '取消成功',
        })
        getList()
      } catch (err) {

      }
    })
    .catch(() => {
    })
}

const handleAdd = () => {
  dialogVisible.value = true
  fetchTeacherList()
}

const handleCancel = () => {
  dialogVisible.value = false
  resetForm()
}

const resetForm = () => {
  form.id = ''
  form.teacherId = ''
  form.teacherName = ''
  form.appointmentTimeId = ''
  form.appointmentDate = ''
  form.lessonTimeKey = ''
  form.lessonTime = ''
  form.classTableStatueId = ''
  form.campus = ''
  form.classRoom = ''
  timeList.value = []
  campusList.value = []
  if (formRef.value) formRef.value.resetFields()
}

const handleConfirm = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (!valid) {
      ElMessage.warning('请完善所有信息');
      return;
    }
    
    // 检查必要字段是否都已填写
    if (!form.teacherId || !form.appointmentTimeId || !form.campus || !form.classRoom) {
      ElMessage.warning('请完善所有信息');
      return;
    }
    
    submitLoading.value = true
    const res = await addCourseScheduling('/pc/classTable/edit', { ...form })
    if (res?.code === 200) {
      ElMessage.success(form.classTableStatueId ? '修改成功' : '新增排课成功')
      dialogVisible.value = false
      resetForm()
      getList()
    }
    submitLoading.value = false
  })
}

getList()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addDialogVisible.value = true)),
        icon: _unref(PlusIcon)
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["icon"])), [
        [_directive_hasPermi, ['system:courseScheduling:add']]
      ])
    ]),
    _createVNode(_component_el_card, { class: "search-box" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "手机号",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: phone.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phone).value = $event)),
                      placeholder: "请输入手机号",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: getList,
                  loading: loading.value,
                  icon: _unref(SearchIcon)
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["loading", "icon"]),
                _createVNode(_component_el_button, {
                  onClick: resetSearch,
                  icon: _unref(RefreshIcon)
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "table-area" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {"width":"100%"},
          border: "",
          stripe: "",
          "highlight-current-row": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "expand" }, {
              default: _withCtx((props) => [
                (props.row.tableList && props.row.tableList.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_el_table, {
                        data: props.row.tableList,
                        border: "",
                        style: {"width":"100%"},
                        stripe: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            prop: "phone",
                            label: "手机号",
                            width: "180"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "teacherName",
                            label: "老师名称",
                            width: "180"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "levelName",
                            label: "级别",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "gradeName",
                            label: "年级",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "subjectName",
                            label: "科目",
                            width: "100"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "classRoomName",
                            label: "校区",
                            width: "150"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "campusName",
                            label: "教室",
                            width: "120"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "appointmentDate",
                            label: "预约日期",
                            width: "120"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "lessonTime",
                            label: "课程时间",
                            width: "120"
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "status",
                            label: "课程状态",
                            width: "100"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.status == 0)
                                ? (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 0,
                                    type: "danger",
                                    effect: "dark"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_el_tag, {
                                    key: 1,
                                    type: "success",
                                    effect: "dark"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "操作",
                            "min-width": "280",
                            prop: "status",
                            fixed: "right"
                          }, {
                            default: _withCtx((scope) => [
                              (scope.row.status == 0)
                                ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                    key: 0,
                                    type: "primary",
                                    size: "small",
                                    onClick: ($event: any) => (handleEdit(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_10
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])), [
                                    [_directive_hasPermi, ['system:courseScheduling:edit']]
                                  ])
                                : _createCommentVNode("", true),
                              (scope.row.status == 0)
                                ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                    key: 1,
                                    type: "danger",
                                    size: "small",
                                    onClick: ($event: any) => (handleCancelClass(scope.row.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])), [
                                    [_directive_hasPermi, ['system:courseScheduling:cancel']]
                                  ])
                                : _createCommentVNode("", true),
                              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                type: "info",
                                size: "small",
                                onClick: ($event: any) => (changeStatus(scope.row))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 2
                              }, 1032, ["onClick"])), [
                                [_directive_hasPermi, ['system:courseScheduling:edit']]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["data"])
                    ]))
                  : (_openBlock(), _createBlock(_component_el_empty, {
                      key: 1,
                      description: "暂无排课数据"
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "studentName",
              label: "学生名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "timeNumber",
              label: "排课数量"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, loading.value]
        ]),
        _createElementVNode("div", _hoisted_13, [
          (tableData.value.length > 0)
            ? (_openBlock(), _createBlock(_component_el_pagination, {
                key: 0,
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: total.value,
                "page-size": pageSize.value,
                "current-page": currentPage.value,
                onSizeChange: handleSizeChange,
                onCurrentChange: handleCurrentChange
              }, null, 8, ["total", "page-size", "current-page"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
      title: form.id ? '编辑排课' : '新增排课',
      width: "1000px",
      onClose: resetForm
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: handleCancel }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleConfirm,
          loading: submitLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "120px",
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "老师",
              prop: "teacherId",
              rules: [{ required: true, message: '请选择老师' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.teacherId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.teacherId) = $event)),
                  placeholder: "请选择老师",
                  onChange: handleTeacherChange,
                  filterable: "",
                  style: {"width":"240px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.userId,
                        label: item.realName,
                        value: item.userId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "预约日期",
              prop: "appointmentDate",
              rules: [{ required: true, message: '请选择日期' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: timeValue.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((timeValue).value = $event)),
                  "value-key": "id",
                  placeholder: "请选择日期",
                  style: {"width":"240px"},
                  onChange: handleTimeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.objId,
                        label: item.label,
                        value: item.label
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "校区教室",
              prop: "classRoom",
              rules: [{ required: true, message: '请选择教室' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: campusList.value,
                  style: {"width":"100%"},
                  border: "",
                  "default-expand-all": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, { type: "expand" }, {
                      default: _withCtx((props) => [
                        (props.row.childList && props.row.childList.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_el_table, {
                                data: props.row.childList,
                                border: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, null, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_checkbox, {
                                        modelValue: scope.row.isSelected,
                                        "onUpdate:modelValue": ($event: any) => ((scope.row.isSelected) = $event),
                                        onChange: (val) => handleCheckboxChange(val, scope.row,props.row),
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_table_column, {
                                    prop: "classroomName",
                                    label: "教室名称"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "date",
                                    label: "日期"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "status",
                                    label: "占用状态"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.status === 1)
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 0,
                                            type: "danger"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_15
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 1,
                                            type: "success"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_16
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "isCurrently",
                                    label: "当前课表占用"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.isCurrently === 1)
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 0,
                                            type: "danger"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_17
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 1,
                                            type: "success"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_18
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["data"])
                            ]))
                          : (_openBlock(), _createBlock(_component_el_empty, {
                              key: 1,
                              description: "暂无教室数据"
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "campusName",
                      label: "校区"
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(AddClass, {
      show: addDialogVisible.value,
      onOnClose: _cache[6] || (_cache[6] = (e) => handleClose(e))
    }, null, 8, ["show"]),
    _createVNode(_component_el_dialog, {
      modelValue: modalshow.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((modalshow).value = $event)),
      title: "修改上课状态",
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (modalshow.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleSubmit,
            loading: statusLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: statusForm,
          "label-width": "auto",
          style: {"max-width":"400px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "上课情况" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: statusForm.type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((statusForm.type) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withCtx(() => [
                        _hoisted_21
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "3" }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})